import { MessagesState, MutationClass } from '../../../models';

export class SetLocaleMutation implements MutationClass {

  public static execute(state: MessagesState, locale: string): void {
    state.locale = locale;
  }

}
